import React from 'react';

import { Box } from '../../UI/Box';
import { Badge as UIBadge } from '../../UI/Badge';
import type { BadgeProps } from '../../UI/Badge';

interface IProps extends BadgeProps {
  badgeContent: number | string;
}

export const Badge: React.FC<IProps> = props => (
  <Box position="relative" width={40} height={40} display="flex" alignItems="center" justifyContent="center">
    {props.children}
    <Box position="absolute" top={-8} right={-8}>
      <UIBadge {...props}>{props.badgeContent}</UIBadge>
    </Box>
  </Box>
);
